import { render } from "./SetRuleWindow.vue?vue&type=template&id=bbc2c7b0"
import script from "./SetRuleWindow.vue?vue&type=script&lang=js"
export * from "./SetRuleWindow.vue?vue&type=script&lang=js"

import "./SetRuleWindow.vue?vue&type=style&index=0&id=bbc2c7b0&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__